import { HttpError } from "@/shared/api/errors"
import type { VerifyPurchaseResponse } from "@/shared/api/generated-backend"
import { zVerifyPurchaseErrorResponse } from "@/shared/api/generated-backend/zod.gen"

export type ClientAction = VerifyPurchaseResponse["client_action"]

export function clientActionFromError(error: unknown): ClientAction {
	const http = findHttpError(error)
	if (!http || http.status >= 500) return "none"
	const body = zVerifyPurchaseErrorResponse
		.pick({ client_action: true })
		.safeParse(http.info)
	if (!body.success) return "none"
	return body.data.client_action
}

function findHttpError(error: unknown): HttpError | null {
	let current = error
	for (let depth = 0; depth < 5; depth++) {
		if (current instanceof HttpError) return current
		if (!current || typeof current !== "object") return null
		current = (current as { cause?: unknown }).cause
	}
	return null
}
